import type { BodyRouteParamsRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { PostContentObjectDetailDataObject } from 'models/service';

type UpdatePost = {
  /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
  attachments?: Array<{ id: string }>;
  community_id?: string;
  html_content: string;
  pinned?: boolean;
  publish_at?: string;
  text_content: string;
  /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
};

type UpdatePostRequestBody = {
  post: UpdatePost;
};

type UpdatePostRouteParameters = {
  id: string;
};

export const updatePost = async ({
  body,
  routeParams,
}: BodyRouteParamsRequest<UpdatePostRequestBody, UpdatePostRouteParameters>) =>
  apiClient.patch<PostContentObjectDetailDataObject, ApiClientResponse<PostContentObjectDetailDataObject>>(
    routes.posts.update(routeParams.id),
    body,
  );
